import { useWeb3React } from '@web3-react/core';
import { BigNumber } from 'ethers';
import { useEffect } from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { hotjar } from 'react-hotjar';
import { SiHomeassistantcommunitystore } from "react-icons/si";
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { ConnectWallet } from 'components/ConnectWallet';
import {
  fetchAccountMagicNftsAsync,
  fetchUserMCRTBalanceAsync,
  setAccountMagicNftsEmptyAsync,
} from 'state/action';
import { useMcrtState, useNFTMarketplaceState } from 'state/hooks';

import bnbLogo from 'assets/icon-bnb.png';
import mcrtLogo from 'assets/icon-mcrt.png';
import LogoWithText from 'assets/logo-with-text.png';
import LogoWithoutText from 'assets/logo-without-text.png';

import { AiFillBank, AiFillStar } from 'react-icons/ai';
import { FaBook, FaGamepad } from 'react-icons/fa';
import {
  GiBlackKnightHelm,
  GiReceiveMoney,
  GiShop,
  GiWallet,
} from 'react-icons/gi';
import { IoMdSwap } from 'react-icons/io';
import { RiDashboardFill } from 'react-icons/ri';

import { FaScaleUnbalancedFlip } from 'react-icons/fa6';
import './Header.scss';

const E18 = BigNumber.from(10).pow(18);
const E9 = BigNumber.from(10).pow(9);

const chainId = Number(process.env.REACT_APP_CHAIN_ID) || 97;

const ConnectButtonStyle = (account) => {
  return {
    position: 'relative',
    backgroundColor: account ? '#232449' : '#316BFF',
    borderRadius: 8,
    border: 'none',
    paddingTop: 10,
    paddingBottom: 10,
    outline: 0,
  };
};

const Header = () => {
  const dispatch = useDispatch();
  const { account } = useWeb3React();
  const location = useLocation();
  const { balance, bnbBalance } = useMcrtState();
  const { inventoryNfts, collection } = useNFTMarketplaceState();
  // const polyMarketUrl = process.env.REACT_APP_POLY_MARKET_URL || "https://magic-craft-theta.vercel.app/";
  const bnb =
    BigNumber.from(bnbBalance.toString()).mul(100).div(E18).toNumber() / 100;
  const mcrtBalance =
    BigNumber.from(balance.toString())
      .mul(100)
      .div(chainId === 56 ? E9 : E18)
      .toNumber() / 100;

  useEffect(() => {
    if (!account) {
      dispatch(setAccountMagicNftsEmptyAsync());
      return;
    }

    if (account) {
      dispatch(fetchAccountMagicNftsAsync(account));
      dispatch(fetchUserMCRTBalanceAsync(account));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  useEffect(() => {
    hotjar.stateChange(location.pathname);
  }, [location.pathname]);

  return (
    <div className="header-sticky">
      <Navbar
        collapseOnSelect
        expand="xl"
        className="bg-header main-header"
        variant="dark"
      >
        <Container fluid className="d-flex align-items-center">
          <Navbar.Brand style={{ marginRight: '0px' }}>
            <div className="header-logo header-logo__normal">
              <Link to="/" rel="noopener noreferrer">
                <img loading="lazy" src={LogoWithText} alt="logo" />
              </Link>
            </div>
            <div className="header-logo header-logo__mobile">
              <Link to="/" rel="noopener noreferrer">
                <img loading="lazy" src={LogoWithoutText} alt="logo" />
              </Link>
            </div>
          </Navbar.Brand>

          <div className="d-flex">
            <Nav className="connect-wallet-btn connect-wallet-btn--mobile mint-page">
              {account && (
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <img loading="lazy" src={mcrtLogo} alt="" />

                    <div
                      className="d-flex flex-column"
                      style={{ marginRight: 20 }}
                    >
                      <h6 className="text-white">{mcrtBalance}</h6>
                      {/* {location.pathname !== '/nft_mint' && (
                        <p className="mb-0">
                          {`${account.substring(0, 6)}...${account.substring(
                            account.length - 4,
                          )}`}
                        </p>
                      )} */}
                    </div>
                  </div>

                  <div className="d-flex align-items-center">
                    <img loading="lazy" src={bnbLogo} alt="" />

                    <div
                      className="d-flex flex-column"
                      style={{ marginRight: 20 }}
                    >
                      <h6 className="text-white">{bnb}</h6>
                    </div>
                  </div>
                </div>
              )}

              <ConnectWallet style={ConnectButtonStyle(account)} />
            </Nav>
            <div className="header-navbar-toggle-container">
              <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                className="header-navbar-toggle"
              >
                <div className="blue-circle" />
                <div className="lines">
                  <span />
                  <span />
                  <span />
                </div>
              </Navbar.Toggle>
            </div>
          </div>

          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="header-navbar-container"
          >
            <Nav className="me-auto d-flex align-items-center">
              <Nav.Link
                as={Link}
                to="/"
                className={`header-menu p-2 text-decoration-none ${location.pathname === '/' ? 'active' : ''
                  }`}
              >
                <div className="navbar-item">
                  <RiDashboardFill />
                  <h6>Dashboard</h6>
                </div>
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/marketplace/explorer"
                className={`header-menu p-2 text-decoration-none ${location.pathname === '/marketplace/explorer' ? 'active' : ''
                  }`}
              >
                <div className="navbar-item">
                  <GiShop />
                  <h6>Marketplace</h6>
                </div>
              </Nav.Link>



              <Nav.Link
                as={Link}
                to="/pledging"
                className={`header-menu p-2 text-decoration-none ${location.pathname === '/pledging' ? 'active' : ''
                  }`}
              >
                <div className="navbar-item">
                  <GiReceiveMoney />
                  <h6>Pledging</h6>
                </div>
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/stats"
                className={`header-menu p-2 text-decoration-none ${location.pathname === '/stats' ? 'active' : ''
                  }`}
              >
                <div className="navbar-item">
                  <GiReceiveMoney />
                  <h6>Stats</h6>
                </div>
              </Nav.Link>


              <NavDropdown
                title={
                  <div className="navbar-item flex-row custom-caret text-dcoration-none" style={{ paddingTop: "2.5px" }}>
                    <span className='icon'>
                      <GiBlackKnightHelm />
                    </span>
                    <h6>NFT</h6>
                    <span className='ps-1  caret'>
                      <svg className="dropdown-caret" width="8" height="5" viewBox="0 0 8 5" fill="none">
                        <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </div>
                }
                id="gaming-dropdown"
                className="header-menu custom-dropdown p-2"
              >
                <NavDropdown.Item
                  as={Link}
                  to="/free_mint"
                  className={`custom-dropdown-item ${location.pathname === '/free_mint' ? 'active' : ''
                    }`}
                >
                  <div className="d-flex align-items-center gap-2">
                    <GiBlackKnightHelm />
                    <h6>Free NFTs</h6>
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/nft_mint"
                  className={`custom-dropdown-item ${location.pathname === '/nft_mint' ? 'active' : ''
                    }`}
                >
                  <div className="d-flex align-items-center gap-2">
                    <GiBlackKnightHelm />

                    <h6>Mint</h6>
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item
                  as="a"
                  href="https://zeus.magiccraft.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="custom-dropdown-item"
                >
                  <div className="d-flex align-items-center gap-2">
                    <GiBlackKnightHelm />
                    <h6>Zeus</h6>
                    <span className="new-badge">NEW</span>
                  </div>
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                title={
                  <div className="navbar-item flex-row custom-caret text-dcoration-none" style={{ paddingTop: "2.5px" }}>
                    <span className='icon'>
                      <SiHomeassistantcommunitystore />
                    </span>
                    <h6>Community Hub</h6>
                    <span className='ps-1  caret'>
                      <svg className="dropdown-caret" width="8" height="5" viewBox="0 0 8 5" fill="none">
                        <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </div>
                }
                id="gaming-dropdown"
                className="header-menu custom-dropdown p-2"
              >

                <NavDropdown.Item
                  as={Link}

                  to="/top_hundred"
                  className={`custom-dropdown-item ${location.pathname === '/top_hundred' ? 'active' : ''
                    }`}
                >
                  <div className="d-flex align-items-center gap-2">
                    <AiFillStar />
                    <h6>Knights</h6>
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}

                  to="https://lobby.magiccraft.io/stats"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`custom-dropdown-item ${location.pathname === 'https://lobby.magiccraft.io/stats' ? 'active' : ''
                    }`} >
                  <div className="d-flex align-items-center gap-2">
                    <FaGamepad />
                    <h6>Game Stats</h6>
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="/dao"
                  as={Link}

                  className={`custom-dropdown-item ${location.pathname === '/dao' ? 'active' : ''
                    }`}                 >
                  <div className="d-flex align-items-center gap-2">
                    <AiFillBank />
                    <h6>DAO</h6>
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item
                  to="https://docs.magiccraft.io/web3-user-guide"
                  target="_blank"
                  as={Link}

                  rel="noopener noreferrer"
                  className={'custom-dropdown-item'}
                >
                  <div className="d-flex align-items-center gap-2">
                    <FaBook />
                    <h6> Web3 User Guide</h6>
                  </div>
                </NavDropdown.Item>
              </NavDropdown>



              <Link
                to="https://pancakeswap.finance/swap?outputCurrency=0x4b8285aB433D8f69CB48d5Ad62b415ed1a221e4f"
                target="_blank"
                rel="noopener noreferrer"
                className={'header-menu p-2 text-decoration-none'}
              >
                <div className="navbar-item">
                  <IoMdSwap />
                  <h6>Buy $MCRT</h6>
                </div>
              </Link>
              {/* <Nav.Link
                href="/verify"
                className={`header-menu p-2 text-decoration-none ${
                  location.pathname === '/verify' ? 'active' : ''
                }`}
              >
                <div className="navbar-item">
                  <GoVerified />
                  <h6>Verify</h6>
                </div>
              </Nav.Link> */}
              <Link
                to="https://lobby.magiccraft.io/"
                target="_blank"
                rel="noopener noreferrer"
                className={'header-menu p-2 text-decoration-none'}
              >
                <div className="navbar-item">
                  <FaGamepad />
                  <h6>Lobby</h6>
                </div>
              </Link>


              {/* <Nav.Link
                as={Link}

                to={polyMarketUrl}
                target='_blank'
                rel="noopener noreferrer"
                className={`header-menu p-2 text-decoration-none  ${location.pathname === polyMarketUrl ? 'active' : ''
                  } `}
              >
                <div className="navbar-item">
                  <FaScaleUnbalancedFlip />
                  <h6>PolyMarket</h6>
                </div>
              </Nav.Link> */}
              {account && (
                <Nav.Link
                  as={Link}

                  to="/marketplace/profile"
                  className={`header-menu p-2 text-decoration-none d-lg-none  ${location.pathname === '/marketplace/profile' ? 'active' : ''
                    }`}
                >
                  <div className="navbar-item">
                    <GiWallet />
                    <h6>{`My Inventory(${inventoryNfts ? inventoryNfts.length : 0
                      })`}</h6>
                  </div>
                </Nav.Link>
              )}
            </Nav>
            {account && (
              <Nav.Link
                as={Link}

                to="/marketplace/profile"
                className={`header-menu p-2 text-decoration-none d-lg-block d-none me-2  ${location.pathname === '/marketplace/profile' ? 'active' : ''
                  }`}
              >
                <div className="navbar-item">
                  <GiWallet />
                  <h6>{`My Inventory(${inventoryNfts ? inventoryNfts.length : 0
                    })`}</h6>
                </div>
              </Nav.Link>
            )}
            <Nav
              className={`connect-wallet-btn connect-wallet-btn--desktop mint-page me-4 ${!account ? 'connected' : ' '
                }`}
            >

              {account && (
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <img loading="lazy" src={mcrtLogo} alt="" />

                    <div
                      className="d-flex flex-column"
                      style={{ marginRight: 40 }}
                    >
                      <h6 className="text-white">{mcrtBalance}</h6>
                      {/* {location.pathname !== '/nft_mint' && (
                        <p className="mb-0">
                          {`${account.substring(0, 6)}...${account.substring(
                            account.length - 4,
                          )}`}
                        </p>
                      )} */}
                    </div>
                  </div>

                  <div
                    className="d-flex align-items-center"
                    style={{ marginTop: 5 }}
                  >
                    <img loading="lazy" src={bnbLogo} alt="" />

                    <div
                      className="d-flex flex-column"
                      style={{ marginRight: 40 }}
                    >
                      <h6 className="text-white">{bnb}</h6>
                    </div>
                  </div>
                </div>
              )}
              <ConnectWallet style={ConnectButtonStyle(account)} />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
